/*
 * @Descripttion:
 * @version:
 * @Author: suiyue
 * @email: 1373842098@qq.com
 * @Date: 2022-04-29 11:09:50
 * @LastEditors: linxi
 * @LastEditTime: 2024-11-07 10:54:11
 */
import _ from 'lodash'
import { fromMaterialJson, Material } from './material'

interface ConfirmationSlot {
  name: string
  value: number
  medicareDeductible ?:any 
  payType?: string
  batchNo?:any
  tenantSupplierName?:any
  medicareDeductibleMoney?:any
  ybzfje?:any
  children: ConfirmationSlot[]
}
export interface PaymentConfirmation {
  [x: string]: any
  patient: string
  amount: number
  prePay?: any
  ids?: any
  errorMaterials: Material[]
  slots: ConfirmationSlot[]
  alarmInfo?: any[]
}

export function fromJson(json: any): PaymentConfirmation {
  const payment = json.payment
  return {
    ...json,
    patient: payment?.patientName || '',
    patientId: payment?.patientId || '',
    treatmentId: payment?.treatmentId || '',
    amount: payment?.shouldPayAmount || 0,
    errorMaterials: _.chain(json.errorRecipeItemList)
      .map((m) => fromMaterialJson(m))
      .value(),
    slots:
      _.chain(json.paymentSummaryList)
        .map((json) => ({
          name: json?.paymentSummary?.billingCategoryName,
          value: json?.paymentSummary?.amount,
          medicareDeductible:'自付金额',
          children: _.chain(json?.paymentItemList)
            .map(
              (json) =>
                ({
                  name: json?.drugName,
                  value: json?.drugAmount,
                  payType: json?.itemPayType,
                  batchNo:json?.batchNo,
                  tenantSupplierName:json?.tenantSupplierName,
                  ybzfje:json?.ybzfje
                } as ConfirmationSlot)
            )
            .value(),
        }))
        .value() || [],
  }
}
